import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { Transforms } from 'vendor/slate'
import { v4 as uuidv4 } from 'uuid'

const insertFile = (editor, path, options) => {
  const file = {
    type: ELEMENT_TYPES.file,
    url: options.url,
    size: options.size,
    title: options.title,
    children: [{ uuid: uuidv4(), text: options.title, parent: { type: ELEMENT_TYPES.file } }]
  }

  Transforms.insertNodes(editor, file, { at: path })
}

export { insertFile }
